/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SmsAuthMethod = {
    Oauth: 'OAUTH',
    Basic: 'BASIC',
    ApiKeyHeader: 'API_KEY_HEADER'
} as const;
export type SmsAuthMethod = typeof SmsAuthMethod[keyof typeof SmsAuthMethod];


export function instanceOfSmsAuthMethod(value: any): boolean {
    for (const key in SmsAuthMethod) {
        if (Object.prototype.hasOwnProperty.call(SmsAuthMethod, key)) {
            if (SmsAuthMethod[key as keyof typeof SmsAuthMethod] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SmsAuthMethodFromJSON(json: any): SmsAuthMethod {
    return SmsAuthMethodFromJSONTyped(json, false);
}

export function SmsAuthMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmsAuthMethod {
    return json as SmsAuthMethod;
}

export function SmsAuthMethodToJSON(value?: SmsAuthMethod | null): any {
    return value as any;
}

export function SmsAuthMethodToJSONTyped(value: any, ignoreDiscriminator: boolean): SmsAuthMethod {
    return value as SmsAuthMethod;
}

